<template>
  <v-dialog :value="value" width="430" persistent>
    <v-card>
      <v-card-title>
        Confirm {{ move ? 'Move' : 'Copy' }}
      </v-card-title>
      <v-card-text>
        {{ confirmText }}
        <v-col v-if="move" cols="auto" class="ma-0 px-0 pb-0 d-inline-flex">
          <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
          <strong>
            Moving this feature will clear its content in this location.
          </strong>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="grey darken-1" text :class="body" @click="$emit('cancel')">
          Cancel
        </v-btn>
        <v-btn :color="move ? 'warning' : 'success'" :class="body" @click="confirm">
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
export default {
  name: 'FeatureMoveDialog',
  props: {
    value: Boolean,
    move: Boolean,
    destinationAd: Object
  },
  mixins: [displayHelpers],
  computed: {
    confirmText() {
      return `${this.move ? 'Move' : 'Copy' } this feature to ad "${this.destinationAd?.ad_name || ''}"?`
    }
  },
  methods: {
    confirm() {
      this.$emit('confirmAction')
    }
  }
}
</script>